export default function scrollTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
